import React, { useEffect, useState } from "react";
import styles from "./Submission.module.scss";
import IconButton from "../../../../components/ButtonIcon/ButtonIcon";
import ems_logo from "../../../../../../images/v2/ems.png";
import nuvei_logo from "../../../../../../images/v2/nuvei.png";
import nab_logo from "../../../../../../images/v2/nab.png";
import priority_logo from "../../../../../../images/v2/priority.png";
import FileIcon from "../../../../assets/svg/icons/common/file";
import Submit from "./SubmitModal";

function SubmissionItem({ processor, processorFiles, appData }) {
  const [expanded, setExpanded] = useState(false);
  const [files, setFiles] = useState([]);
  const [openSubmit, setOpenSubmit] = useState(false);

  const getLogo = (processor) => {
    if (processor == "ems") return ems_logo;
    if (processor == "nuvei") return nuvei_logo;
    if (processor == "nab") return nab_logo;
    if (processor == "priority") return priority_logo;
  };

  useEffect(() => {
    Object.entries(processorFiles).forEach(([bank, files]) => {
      if (bank.toLowerCase().includes(processor.value)) {
        setFiles(files);
      }
    });
  }, [processorFiles]);

  return (
    <>
      <div className={styles.submission_item}>
        <div className={styles.item_head}>
          <input type="checkbox" />
          <IconButton onClick={() => setExpanded(!expanded)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M11.3537 8.35403L6.35372 13.354C6.30727 13.4005 6.25212 13.4373 6.19142 13.4625C6.13072 13.4876 6.06567 13.5006 5.99997 13.5006C5.93428 13.5006 5.86922 13.4876 5.80852 13.4625C5.74783 13.4373 5.69268 13.4005 5.64622 13.354C5.59977 13.3076 5.56292 13.2524 5.53778 13.1917C5.51263 13.131 5.49969 13.066 5.49969 13.0003C5.49969 12.9346 5.51263 12.8695 5.53778 12.8088C5.56292 12.7481 5.59977 12.693 5.64622 12.6465L10.2931 8.00028L5.64622 3.35403C5.5524 3.26021 5.49969 3.13296 5.49969 3.00028C5.49969 2.8676 5.5524 2.74035 5.64622 2.64653C5.74004 2.55271 5.86729 2.5 5.99997 2.5C6.13265 2.5 6.2599 2.55271 6.35372 2.64653L11.3537 7.64653C11.4002 7.69296 11.4371 7.74811 11.4623 7.80881C11.4874 7.86951 11.5004 7.93457 11.5004 8.00028C11.5004 8.06599 11.4874 8.13105 11.4623 8.19175C11.4371 8.25245 11.4002 8.30759 11.3537 8.35403Z"
                fill="#3A383F"
              />
            </svg>
          </IconButton>
        </div>

        <div className={styles.body}>
          <div className={styles.processor}>
            <img src={getLogo(processor.value)} />
            <h6>{processor.value}</h6>
          </div>

          <div className={styles.action}>
            {/* <p>Sent:24/12/2019</p> */}
            <IconButton
              bgColor={"#4C70EF"}
              textColor="#FFF"
              onClick={() => {
                setOpenSubmit(true);
              }}
            >
              Submit
            </IconButton>
          </div>
        </div>
      </div>

      <div
        className={`${styles.submission_data} ${expanded ? styles.expanded : ""}`}
      >
        {expanded && (
          <div
            className={`${styles.submission_data_list} ${expanded ? styles.submitted : ""}`}
          >
            {files.map((file, index) => (
              <div key={index} className={styles.list_item}>
                <FileIcon />
                <span>{file}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <Submit
        isOpen={openSubmit}
        onClose={() => {
          setOpenSubmit(false);
        }}
        appData={appData}
        files={files}
        processor={processor}
      />
    </>
  );
}

export default SubmissionItem;
